import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=6aa35c4d&scoped=true&lang=html&"
import script from "./Faq.vue?vue&type=script&lang=js&"
export * from "./Faq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa35c4d",
  null
  
)

export default component.exports